<template>
  <div class="flex column" style="width: 100vm" v-title data-title="其他问题">
    <div v-for="(data, index) in list" :key="index">
      <div class="flex column" style="height: 49px; margin: 0 16px" @click="$router.push({name:'QuestionDetail', params: {question: JSON.stringify(data)}})">
        <div class="flex main-space-between cross-center" style="height: 49px;">
          <span>{{index + 1}}.{{data.title}}</span>
          <img src="../assets/arrow_right.png" style="width: 7px; height: 13px">
        </div>
        <div style="background: #EEEEEEFF; height: 1px; width: 100%"></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "AboutStudentBook",
    data () {
      return{
        list: [
          {
            title: '阅伴的图书是怎样选择和分类的？',
            detailTexts: [{title: '首先，经典的。通过时间沉淀下的东西，一定有它独有的价值；'},
              {title: '其次，全科的。文学的、科学的、历史的等，全方位提升孩子的素养；'},
              {title: '再次，适龄的。让孩子在合适的时间读到合适的书。'},
              {title: '最后，共读的。每学年组织四期共读。分为“上学期共读”、“寒假共读”、“下学期共读”、“暑假共读”。'}]
          },
          {
            title: '如何购买图书呢？',
            detailTitle: '购买图书您可以通过以下方式',
            detailTexts: [{title: '方式1：在阅伴App点击“书店"，跳转到“阅伴书店"，即可购买图书。'},
              {title: '方式2：在淘宝和微店直接索“阅伴书店”，即可购买图书'}]
          }
        ]
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AboutStudentBook.vue